import { Link } from "react-router-dom";

export default function TrendingSection({ title, posts }) {
    // 🔒 ALWAYS NORMALIZE TO ARRAY
    const safePosts = Array.isArray(posts)
        ? posts
        : Array.isArray(posts?.items)
            ? posts.items
            : [];

    if (safePosts.length === 0) return null;

    // ✅ REMOVE DUPLICATES SAFELY
    const uniquePosts = Array.from(
        new Map(safePosts.map((p) => [p.id, p])).values()
    );

    const main = uniquePosts[0];
    const side = uniquePosts.slice(1, 4);

    // slug for category page
    const categorySlug = title.toLowerCase().replace(/\s+/g, "-");

    return (
        <section className="sport-section">
            {/* SECTION HEADER */}
            <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-extrabold capitalize border-l-4 border-orange-500 pl-3">
                    {title}
                </h2>

                {/* VIEW ALL LINK */}
                <Link
                    to={`/category/${categorySlug}`}
                    className="text-sm font-semibold text-orange-600 hover:underline"
                >
                    View All →
                </Link>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                {/* FEATURED CARD */}
                <Link
                    to={`/article/${main.slug}`}
                    className="relative lg:col-span-2 rounded-2xl overflow-hidden group"
                >
                    <img
                        src={main.images || "/logo-blogysports.png"}
                        alt={main.title}
                        className="w-full h-[360px] object-cover group-hover:scale-105 transition duration-300"
                    />

                    {/* GRADIENT OVERLAY */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

                    {/* CATEGORY BADGE */}
                    <span className="absolute top-4 left-4 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full capitalize">
                        {main.category}
                    </span>

                    {/* TITLE */}
                    <h3 className="absolute bottom-5 left-5 right-5 text-white text-2xl font-extrabold leading-snug">
                        {main.title}
                    </h3>
                </Link>

                {/* SIDE ARTICLES */}
                <div className="flex flex-col gap-4">
                    {side.map((item) => (
                        <Link
                            key={item.id}
                            to={`/article/${item.slug}`}
                            className="flex gap-4 items-center bg-white rounded-xl p-3 shadow hover:shadow-md transition"
                        >
                            <img
                                src={item.images || "/logo-blogysports.png"}
                                alt={item.title}
                                className="w-24 h-20 object-cover rounded-lg flex-shrink-0"
                            />

                            <div>
                                <h4 className="font-semibold text-sm line-clamp-2">
                                    {item.title}
                                </h4>
                                <span className="text-xs text-gray-500 capitalize">
                                    {item.category}
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
